import { HfsSettingsAction } from 'fleet-data-model';

export enum ControlType {
  GROUP = 'GROUP',
  RADIO = 'RADIO',
  RANGE = 'RANGE',
  TOGGLE = 'TOGGLE',
  TEMPERATURE = 'TEMPERATURE',
}

export enum SettingTypeEnum {
  FrostSensor = 'FROST_SENSOR',
  ObjectAvoidance = 'OBJECT_AVOIDANCE',
  RainGuardEnabled = 'MOWER_SMART_RAIN_GUARD_ENABLED',
  FrostGuardEnabled = 'MOWER_SMART_FROST_GUARD',
  FrostSensorEnabled = 'FROST_SENSOR_ENABLED',
  FrostSensorTempLimit = 'FROST_SENSOR_TEMP_LIMIT',
  FairwayCuttingEnabled = 'FAIRWAY_CUTTING',
  EcoMode = 'ECO_MODE',
  MowerHouse = 'MOWER_HOUSE',
  WeatherTimer = 'WEATHER_TIMER',
  SpotCutting = 'SPOT_CUTTING',
  ObstacleAvoidanceGroup = 'OBSTACLE_AVOIDANCE_GROUP',
  ObstacleAvoidanceEnabled = 'OBSTACLE_AVOIDANCE_ENABLED',
  ObstacleAvoidanceProfile = 'OBSTACLE_AVOIDANCE_VISION_PROFILE',
  ObstacleAvoidanceKeepRunningWithReducedPerformance = 'OBSTACLE_AVOIDANCE_VISION_KEEP_RUNNING_WITH_REDUCED_PERFORMANCE_ENABLED',
  FacilityModeEnabled = 'FACILITY_MODE_ENABLED',
  HeadlightsMode = 'HEADLIGHTS_MODE',
  Headlights = 'HEADLIGHTS',
  HeadlightsErrorIndication = 'HEADLIGHTS_ERROR_INDICATION',
  HeadlightsTheme = 'HEADLIGHTS_THEME',
  TheftProtection = 'THEFT_PROTECTION',
  Geofence = 'GEOFENCE',
  GeofenceCentralPoint = 'GEOFENCE_CENTRAL_POINT',
}

export enum GroupControlAlignment {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export enum RangeControlUnits {
  METERS = 'meters',
  MINUTES = 'min',
}

type DependenciesMap = {
  readonly?: DependenciesCombination[];
  hidden?: DependenciesCombination[];
};

export type Dependency = {
  settingType: string;
  enabled?: boolean;
  confirmedEnabled?: boolean;
  value?: string | number;
};

type DependenciesCombination = Dependency[];

export type RadioOption = {
  hintKey?: string;
  titleKey: string;
  value: string;
  selected?: boolean;
};
export type UpdateError = {
  assetId: string;
  settingType: string;
  errorKey: string;
};

/* Setting control as we get it from BFF */
export type SettingControl = {
  controlType: ControlType | string;
  settingType: SettingTypeEnum | string;
  titleKey: string;
  errorKey?: string;
  tooltipTitleLangKey?: string;
  tooltipLangKey?: string;
  descriptionKey?: string;
  descriptionParams?: any;
  editable?: boolean;
  hidden?: boolean;
  invalidValue?: boolean;
  dependencies?: DependenciesMap;
  enabled?: boolean;
  value?: string | number;
  options?: RadioOption[];
  group?: SettingControl[];
  groupIncludes?: ControlType[];
  minValue?: number;
  maxValue?: number;
  stepSize?: number;
  alignment?: GroupControlAlignment;
  units?: RangeControlUnits;
  hfsAction?: HfsSettingsAction;
};

/* Setting control, decorated with extra attributes for visualisation purposes */
export type VisualSettingControl = SettingControl & {
  isLoading?: boolean;
  isDirty?: boolean;
};

/* Indicates the lifecycle position of the update record, stored in redux */
export enum Status {
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
}

/* Minimal version of the modification record, suitable for draft phase */
export type SettingValuePair = {
  settingType: SettingTypeEnum;
  enabled?: boolean;
  value?: string | number;
};

/* The representation of the modification record when it evolves higher then draft */
export type Update = SettingValuePair & {
  assetId: string;
  status: Status;
  group?: SettingValuePair[];
  timestamp?: number;
  operationIds: string[];
  failedOperationIds: string[];
  successOperationIds: string[];
  hfsAction?: HfsSettingsAction;
};

export interface HfsSettingsStatuses {
  facilityMode: boolean;
}
